<template>
  <section class="register">
    <div class="box">
      <div class="header">
         <transition name="title">
          <div v-if="page === 0" key="update" class="title" style="text-transform: capitalize">{{ name }}</div>
          <div v-if="page === 1" key="info" class="title">Informações</div>
          <div v-if="page === 2" key="remove" class="title">Excluir</div>
        </transition>
        <div @click="$router.push('/ticket-type')" class="close"><i class="fas fa-times"></i></div>
      </div>
      <transition name="page">
        <!-- Ações -->
        <div v-if="page === 0" key="page-0">
          <form @submit.prevent class="form">
            <button @click="page = 1" class="button-form" type="button"><i class="fas fa-info-circle"></i><span>Informações</span></button>
            <button @click="page = 2" class="button-form" type="button"><i class="fas fa-trash-alt"></i><span>Excluir</span></button>
          </form>
        </div>
        <!-- Informações -->
        <div v-if="page === 1" key="page-1">
          <form @submit.prevent class="form">
            <!-- Nome -->
            <label>Nome</label>
            <input v-model="name" type="text" placeholder="Inteira, Meia, ..." :class="{ error : error.includes('name') || error.includes('table')  }" style="text-transform: capitalize" />
            <div v-if="error.indexOf('name') > -1" class="hint">você esqueceu de digitar o nome</div>
            <div v-if="error.indexOf('table') > -1" class="hint">O nome não pode começar com "Mesa "</div>
            <div v-if="error.indexOf('invite') > -1" class="hint">O nome não pode começar com "Convite "</div>
            <!-- Percentagem -->
            <label>Percentagem</label>
            <input v-model="percentage" type="number" placeholder="% do valor" :class="{ error : error.indexOf('percentage') > -1 || error.indexOf('login-exists') > -1 }" style="max-width: 80px" />
            <div v-if="error.indexOf('percentage') > -1" class="hint">você esqueceu de digitar a percentagem</div>
            <!-- Default -->
            <label class="switch">
              <input v-model="def" type="checkbox">
              <span class="slider"></span>
              <span class="text">Padrão para os eventos</span>
            </label>
            <!-- Sell -->
            <label class="switch">
              <input v-model="sell" type="checkbox">
              <span class="slider"></span>
              <span class="text">Disponível para compra online</span>
            </label>
            <!-- Special -->
            <label class="switch">
              <input v-model="special" type="checkbox">
              <span class="slider"></span>
              <span class="text">Cadeirante / Necessidades especiais</span>
            </label>
          </form>
          <div class="actions">
            <button @click="page = 0" class="button-previous" :style="id === 'new' ? 'visibility: hidden' : 'visibility: visible'"><i class="fas fa-angle-left"></i><span>Voltar</span></button>
            <button @click="createUpdate" class="button-save">
              <i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i>
              <span>{{ id === 'new' ? 'Confirmar' : 'Atualizar' }}</span>
            </button>
          </div>
        </div>
        <!-- Remover -->
        <div v-if="page === 2" key="page-2">
          <form @submit.prevent class="form">
            <label>Confirma exclusão do tipo {{ name }}?</label>
          </form>
          <div class="actions">
            <button @click="page = 0" class="button-previous"><i class="fas fa-angle-left"></i><span>Voltar</span></button>
            <button @click="remove" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Confirmar</span></button>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { get, create, update, remove } from '../api/ticketType'

export default {
  name: 'ticketType',

  props: ['id'],
  data () {
    return {
      page: 0,
      loading: false,
      error: [],
      name: null,
      ticketDesc: null,
      percentage: null,
      def: false,
      sell: false,
      special: false
    }
  },
  async mounted () {
    // Update
    if (this.id !== 'new') {
      try {
        const type = await get(this.id)
        this.name = type.name
        this.desc = type.ticketDesc
        this.percentage = type.percentage
        this.def = type.default
        this.sell = type.sell
        this.special = type.special
      } catch (error) {
        logger.error(error, this)
      }
    } else {
      this.page = 1
    }
  },
  methods: {
    async createUpdate () {
      try {
        if (this.loading) return false
        if (this.name.toUpperCase().startsWith('MESA')) {
          this.error = ['table']
          return false
        }
        if (this.name.toUpperCase().startsWith('CONVITE')) {
          this.error = ['invite']
          return false
        }
        this.loading = true
        this.error = []
        if (this.id === 'new') {
          // Create ticket type
          await create(
            this.name,
            this.desc,
            this.percentage,
            this.def,
            this.sell,
            this.special
          )
        } else {
          // Update ticket type
          await update(
            this.id,
            this.name,
            this.desc,
            this.percentage,
            this.def,
            this.sell,
            this.special
          )
        }
        this.loading = false
        this.$router.push('/ticket-type')
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
        this.loading = false
      }
    },
    async remove () {
      this.loading = true
      try {
        await remove(this.id)
        this.$router.push('/ticket-type')
      } catch (error) {
        logger.error(error, this)
      }
      this.loading = false
    }
  }
}
</script>
